// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
/* eslint-disable filename-export/match-default-export */
import React from 'react';
import pt from 'prop-types';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';

import { MrCard } from '@ion/components';
import { Typography, Chip, Stack } from '@metarouter-private/mr-mui';

import IntegrationLogo from '../../components/integrations/integration-logo';

import useTrackWithUser from '@ion/api/hooks/useTrackWithUser';

import styles from '../index.module.scss';

const StarterkitCard = ({ starterkitId, friendlyName, isBeta }) => {
  const history = useHistory();
  const [trackIntegrationOpened] = useTrackWithUser('new_integration_opened');

  const handleOnClick = () => {
    trackIntegrationOpened({ starterkitId, starterkitName: friendlyName });
    history.push({
      state: {
        starterkitId,
      },
    });
  };

  const cardTitle = friendlyName || starterkitId;

  return (
    <MrCard className={cx(styles.card, styles.integrationCard)} styleNames="link" onClick={handleOnClick}>
      <IntegrationLogo id={starterkitId} className={styles.logo} />

      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h5" ellipsis title={cardTitle}>
          {cardTitle}
        </Typography>

        {isBeta && <Chip label="BETA" size="small" variant="outlined" color="secondary" />}
      </Stack>
    </MrCard>
  );
};

StarterkitCard.propTypes = {
  friendlyName: pt.string,
  starterkitId: pt.string.isRequired,
  isBeta: pt.bool,
};

export default StarterkitCard;
